// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReadyPlanStatusFilterMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadyPlanStatusFilterMetadataQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', readyPlanStatus: Array<{ __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }> } };


export const ReadyPlanStatusFilterMetadataDocument = gql`
    query ReadyPlanStatusFilterMetadata {
  enumDetails {
    readyPlanStatus {
      code
      name
    }
  }
}
    `;

/**
 * __useReadyPlanStatusFilterMetadataQuery__
 *
 * To run a query within a React component, call `useReadyPlanStatusFilterMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadyPlanStatusFilterMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadyPlanStatusFilterMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useReadyPlanStatusFilterMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>(ReadyPlanStatusFilterMetadataDocument, options);
      }
export function useReadyPlanStatusFilterMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>(ReadyPlanStatusFilterMetadataDocument, options);
        }
// @ts-ignore
export function useReadyPlanStatusFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>;
export function useReadyPlanStatusFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReadyPlanStatusFilterMetadataQuery | undefined, ReadyPlanStatusFilterMetadataQueryVariables>;
export function useReadyPlanStatusFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>(ReadyPlanStatusFilterMetadataDocument, options);
        }
export type ReadyPlanStatusFilterMetadataQueryHookResult = ReturnType<typeof useReadyPlanStatusFilterMetadataQuery>;
export type ReadyPlanStatusFilterMetadataLazyQueryHookResult = ReturnType<typeof useReadyPlanStatusFilterMetadataLazyQuery>;
export type ReadyPlanStatusFilterMetadataSuspenseQueryHookResult = ReturnType<typeof useReadyPlanStatusFilterMetadataSuspenseQuery>;
export type ReadyPlanStatusFilterMetadataQueryResult = ApolloReactCommon.QueryResult<ReadyPlanStatusFilterMetadataQuery, ReadyPlanStatusFilterMetadataQueryVariables>;